import ConsentTerm from './ConsentTerm';

import TelemedicineContext from '../../context/telemedicine';
import { createConsentTerm, getConsentTerm } from '../../services/telemedicine-term';

import { DateUtils, showErrorToast } from '@amigoapp/doca-react';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ConsentTermContainer = () => {
	const navigate = useNavigate();
	const [consentTerm, setConsentTerm] = useState(null);
	const [loading, setLoading] = useState(true);
	const { updateTelemedicine } = useContext(TelemedicineContext);

	const handleFetchConsentTerm = useCallback(async () => {
		const { data } = await getConsentTerm();

		setLoading(false);
		setConsentTerm(data);
	}, []);

	const onBackClick = useCallback(() => {
		navigate('/home');
	}, [navigate]);

	const onAcceptConsentTermClick = useCallback(async () => {
		setLoading(true);

		const { data } = await createConsentTerm();

		if (data) {
			window.socket.emit('telemedicine:patient-connected');
			updateTelemedicine({ signed_at: DateUtils.now() });
			navigate('/waiting-room');
		} else {
			showErrorToast('Não foi possível criar o termo.');
		}

		setLoading(false);
	}, [navigate, updateTelemedicine]);

	useEffect(() => {
		handleFetchConsentTerm();
	}, [handleFetchConsentTerm]);

	return (
		<ConsentTerm
			consentTerm={consentTerm}
			loading={loading}
			onAcceptConsentTermClick={onAcceptConsentTermClick}
			onBackClick={onBackClick}
		/>
	);
};

export default ConsentTermContainer;
